import styled from 'styled-components'
import { Button } from '../../globalStyles'

export const AboutContainer = styled.div`
    text-align: center;
    font-size: 1.25rem;
    padding-bottom: 2rem;
`

export const AboutTitle = styled.p`
    text-align: center;
    font-size: 2rem;
`

export const AboutImgContainer = styled.img`
    width: 50%;
    border-style: dotted;
`

export const AbouTextContainer = styled.div`
    padding: 20px;
    margin: 1rem 1rem 1rem 1rem;
`

export const AboutNotesContainer = styled.div`
    align-text: left;
`